import React, { Component } from 'react'
import './OurStory.css';
import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class OurStory extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    render() {
        return (
            <React.Fragment>
                <LayoutWrapper />

                <main className="main main-container">

                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Our Story</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                    <div className="elementor-widget-container ctnr">
                        <h2 className="elementor-heading-title elementor-size-default story-fnt">Our Story</h2>
                    </div>
                    <div className="elementor-text-editor elementor-clearfix bdr">
                        <p className="pg">
                            <span style={{"fontWeight": "400"}}>
                                Our Story starts here with being a passionate innovator and able to bring you an unique experience with StyleCabbie..
                            </span>
                        </p>
                        <p className="pg">
                            <span style={{"fontWeight": "400"}}>&nbsp;
                            </span>
                            <span style={{"fontWeight": "400"}}>
                                &nbsp;#BeYourself , #ProudStyler,&nbsp; #ShareStyleIdeas,&nbsp; #StyleCabbiePromoters
                            </span>
                        </p>
                        <p className="pg">
                            <span style={{"fontWeight": "400"}}>
                                Our Values
                            </span>
                        </p>
                        <h3 className="pg">
                            PASSION – 
                        </h3>
                        <p className="pg">
                            <span style={{"fontWeight": "400"}}>
                            We are committed to being a reliable and accountable member of the StyleCabbie team. 
                            We build relationships that foster loyalty and long-term success.
                            </span>
                        </p>
                        <p className="pg">&nbsp;</p>
                        <h3 className="pg">
                            EXCELLENCE –
                        </h3>
                        <p className="pg"><span style={{"fontWeight": "300"}}>
                            We work hard to exceed expectations in everything we do by paying attention to the details, 
                            always going the extra mile and continuously improving.
                            </span>
                        </p>
                        <p className="pg">&nbsp;</p>
                        <h3 className="pg">
                            WARMTH –&nbsp;
                        </h3>    
                        <p className="pg"><span style={{"fontWeight": "300"}}>
                            Act with warmth and authenticity in all interactions and treat everyone equally and with respect.
                            </span>
                        </p>                        
                        <p className="pg">&nbsp;</p>
                        <h3 className="pg">
                            UNITY –
                        </h3>
                        <p className="pg"><span style={{"fontWeight": "300"}}>
                            Our goal is to work together and have open communication and cooperation across all teams and levels.
                            </span>
                        </p>                        
                    </div>
                </main>
                <Footer />
            </React.Fragment>
        )
    }
}
export default  OurStory 
